import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Boikpi from "./Boikpi";
import ServicesAgeing from "./ServicesAgeing";
import BoiAgeing from "./BoiAgeing";
import WorkOrder from "./WorkOrder";
import Vendors from "./Vendors";
import ServicesStatus from "./ServicesStatus";
import BoiStatus from "./BoiStatus";
import LeadSummary from "./LeadSummary";
import ServicesDues from "./ServicesDues";
import ServicesKpi from "./ServicesKpi";
import BoiDues from "./BoiDues";
import BoiVendors from "./BoiVendors";
import { useGetAgeingAnalysisBoughtOutItemsQuery, useGetKpiDataQuery, useGetAgeingAnalysisServicesQuery, useGetFloatingRfqDueThisMonthQuery, useGetLongLeadItemsQuery, useGetProcurementStatusBoughtOutItemsQuery, useGetProcurementStatusServicesQuery, useGetReleasePoThisWeekQuery, useGetTopVendorsBoughtOutItemsQuery, useGetTopVendorsServicesQuery, useGetWorkOrderByDepartmentQuery } from "store/slices/apis/procurementDashboardSlice";
import { useParams } from "react-router-dom";
import moment from "moment";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import { PROCUREMENT_DASHBOARD_CONFIG } from "config";
import { enterpriseTokens } from "styles/theme";

const ProcurementDashboard = () => {
  const { projectId } = useParams();

  const currentDashboardConfig = PROCUREMENT_DASHBOARD_CONFIG[projectId] || PROCUREMENT_DASHBOARD_CONFIG.default;

  const { data: kpiData, isFetching: kpiataLoading, isError: kipDataError } = useGetKpiDataQuery({ projectId });
  const { data: workOrderData, isFetching: workOrderLoading, isError: workOrderError } = useGetWorkOrderByDepartmentQuery({ projectId });
  const { data: ageingServicesData, isFetching: ageingServicesLoading, isError: ageingServicesError } = useGetAgeingAnalysisServicesQuery({ projectId });
  const { data: ageingBoiData, isFetching: ageingBoiLoading, isError: ageingBoiError } = useGetAgeingAnalysisBoughtOutItemsQuery({ projectId });
  const { data: longLeadData, isFetching: longLeadLoading, isError: longLeadError } = useGetLongLeadItemsQuery({ projectId });
  const { data: vendorServicesData, isFetching: vendorServicesLoading, isError: vendorServicesError } = useGetTopVendorsServicesQuery({ projectId });
  const { data: vendorBoiData, isFetching: vendorBoiLoading, isError: vendorBoiError } = useGetTopVendorsBoughtOutItemsQuery({ projectId });
  const { data: statusServicesData, isFetching: statusServicesLoading, isError: statusServicesError } = useGetProcurementStatusServicesQuery({ projectId });
  const { data: statusBoiData, isFetching: statusBoiLoading, isError: statusBoiError } = useGetProcurementStatusBoughtOutItemsQuery({ projectId });
  const startMonthDate = moment.utc().startOf("month").format();
  const endMonthDate = moment.utc().endOf("month").format();
  const { data: floatingRfqData, isFetching: floatingRfqLoading, isError: floatingRfqError } = useGetFloatingRfqDueThisMonthQuery({ projectId, startDate: startMonthDate, endDate: endMonthDate });
  const startWeekDate = moment.utc().startOf("isoWeek").format();
  const endWeekDate = moment.utc().endOf("isoWeek").format();
  const { data: releasePoData, isFetching: releasePooading, isError: releasePoError } = useGetReleasePoThisWeekQuery({ projectId, startDate: startWeekDate, endDate: endWeekDate });

  const { data: procurementData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

  return (
    <>
      <Grid container spacing={"10px"} sx={{ p: 0, pb: 6 }}>
        <Grid size={12} sx={{ bgcolor: "#fff", p: 2, pt: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                gap: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "18px", sm: "32px", md: "36px" },
                  lineHeight: { xs: "16px", md: "48px" },
                  color: "#252C32",
                  fontFamily: "Outfit, sans-serif",
                }}
              >
                Procurement Delivery
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#252C32",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              Monitor package progress, supplier commitments, and procurement schedule exposure.
            </Typography>
          </Box>
        </Grid>
        <Grid size={12} sx={{ px: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", pb: 0.75, borderBottom: `1px solid ${enterpriseTokens.lineSoft}`, "& .MuiTypography-root": { fontSize: "12px", color: enterpriseTokens.muted } }}>
            <ProjectLastUpdatedOn date={procurementData?.procurement} />
          </Box>
        </Grid>
        <Grid container columnSpacing={1.5} rowSpacing={1.5} sx={{ px: 2 }}>
          <Grid size={{ xs: 12, md: 12 }}>
            <ServicesKpi data={kpiData?.data} isError={kipDataError} isLoading={kpiataLoading} />
          </Grid>
          {/* <Grid size={{ xs: 12, md: 6 }}>
            <Boikpi />
          </Grid> */}
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ServicesStatus data={statusServicesData?.data} isError={statusServicesError} isLoading={statusServicesError} />
            </Box>
          </Grid>
          {
            currentDashboardConfig.showBoi && (
              <Grid size={{ sx: 12, md: 6 }}>
                <Box
                  sx={{
                    background: "#fff",
                    borderRadius: "3px",
                    p: 0,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                    border: "1px solid #E2E8F0",
                overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <BoiStatus data={statusBoiData?.data} isError={statusBoiError} isLoading={statusBoiLoading} />
                </Box>
              </Grid>
            )
          }
          {/* <Grid size={{ xs: 12, md: 7 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <LeadSummary />
            </Box>
          </Grid> */}
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ServicesAgeing data={ageingServicesData?.data} isError={ageingServicesError} isLoading={ageingServicesLoading} />
            </Box>
          </Grid>
          {
            currentDashboardConfig.showBoi && (
              <Grid size={{ sx: 12, md: 6 }}>
                <Box
                  sx={{
                    background: "#fff",
                    borderRadius: "3px",
                    p: 0,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                    border: "1px solid #E2E8F0",
                overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <BoiAgeing data={ageingBoiData?.data} isError={ageingBoiError} isLoading={ageingBoiLoading} />
                </Box>
              </Grid>
            )
          }
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ServicesDues data={floatingRfqData?.data} isError={floatingRfqError} isLoading={floatingRfqLoading} />
            </Box>
          </Grid>
          {
            currentDashboardConfig.showBoi && (
              <Grid size={{ sx: 12, md: 6 }}>
                <Box
                  sx={{
                    background: "#fff",
                    borderRadius: "3px",
                    p: 0,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                    border: "1px solid #E2E8F0",
                overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <BoiDues data={releasePoData?.data} isError={releasePoError} isLoading={releasePooading} />
                </Box>
              </Grid>
            )
          }
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <WorkOrder data={workOrderData?.data} isError={workOrderError} isLoading={workOrderLoading} />
            </Box>
          </Grid>
          {
            currentDashboardConfig.showBoi && (
              <Grid size={{ sx: 12, md: 6 }}>
                <Box
                  sx={{
                    background: "#fff",
                    borderRadius: "3px",
                    p: 0,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                    border: "1px solid #E2E8F0",
                overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <LeadSummary data={longLeadData?.data} isError={longLeadError} isLoading={longLeadLoading} />
                </Box>
              </Grid>
            )
          }
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <Vendors data={vendorServicesData?.data} isError={vendorServicesError} isLoading={vendorServicesLoading} />
            </Box>
          </Grid>
          {
            currentDashboardConfig.showBoi && (
              <Grid size={{ sx: 12, md: 6 }}>
                <Box
                  sx={{
                    background: "#fff",
                    borderRadius: "3px",
                    p: 0,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                    border: "1px solid #E2E8F0",
                overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <BoiVendors data={vendorBoiData?.data} isError={vendorBoiError} isLoading={vendorBoiLoading} />
                </Box>
              </Grid>
            )
          }
        </Grid>
      </Grid>
    </>
  );
};

export default ProcurementDashboard;
